type StorageType = 'local' | 'session';

interface StorageOptions {
  type?: StorageType;
}

function getStorage(type: StorageType): Storage {
  return type === 'local' ? localStorage : sessionStorage;
}

export function getItem<T>(
  key: string,
  options: StorageOptions = {}
): T | null {
  const { type = 'local' } = options;
  const storage = getStorage(type);

  try {
    const item = storage.getItem(key);
    if (item === null) return null;
    return JSON.parse(item) as T;
  } catch {
    console.warn(`[Storage] Failed to parse item: ${key}`);
    return null;
  }
}

export function setItem<T>(
  key: string,
  value: T,
  options: StorageOptions = {}
): void {
  const { type = 'local' } = options;
  const storage = getStorage(type);

  try {
    storage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`[Storage] Failed to set item: ${key}`, error);
  }
}

export function removeItem(key: string, options: StorageOptions = {}): void {
  const { type = 'local' } = options;
  const storage = getStorage(type);
  storage.removeItem(key);
}

export function clearStorage(options: StorageOptions = {}): void {
  const { type = 'local' } = options;
  const storage = getStorage(type);
  storage.clear();
}

export const storage = {
  get: getItem,
  set: setItem,
  remove: removeItem,
  clear: clearStorage,
};

export const AUTH_TOKEN_KEY = 'auth_token';
export const AUTH_USER_KEY = 'auth_user';
